import React, { useState } from 'react';
import { Card, FilterPills, Pill } from '../components/UI';
import s from './Invoices.module.css';

const ALL_INVOICES = [
  { no:'INV-2024-1183', supplier:'Bharat Petro Supplies', date:'02 Jul', amount:'₹18.4 L', gst:'✔ Valid', comp:94, compColor:'var(--accent)', risk:'Low', riskColor:'var(--accent)', status:'ready', statusLabel:'Ready', action:'Review', actionScreen:'validation' },
  { no:'INV-2024-1182', supplier:'Chennai Chemicals Ltd', date:'02 Jul', amount:'₹6.2 L', gst:'✔ Valid', comp:72, compColor:'var(--warn)', risk:'Medium', riskColor:'var(--warn)', status:'pending', statusLabel:'Pending', action:'Review', actionScreen:'validation' },
  { no:'INV-2024-1181', supplier:'Reliance Trading Co.', date:'01 Jul', amount:'₹42.0 L', gst:'✔ Valid', comp:89, compColor:'var(--accent)', risk:'Low', riskColor:'var(--accent)', status:'ready', statusLabel:'Ready', action:'Review', actionScreen:'validation' },
  { no:'INV-2024-1180', supplier:'IndoLub Pvt Ltd', date:'01 Jul', amount:'₹3.8 L', gst:'⚠ Mismatch', comp:41, compColor:'var(--danger)', risk:'High', riskColor:'var(--danger)', status:'risk', statusLabel:'High risk', action:'Investigate', actionScreen:'fraud' },
  { no:'INV-2024-1179', supplier:'Tamil Agro Fuels', date:'30 Jun', amount:'₹11.0 L', gst:'✔ Valid', comp:81, compColor:'var(--info)', risk:'Low', riskColor:'var(--info)', status:'review', statusLabel:'In review', action:'Track', actionScreen:'workflow' },
  { no:'INV-2024-1178', supplier:'SunTech Lubricants', date:'30 Jun', amount:'₹7.5 L', gst:'✔ Valid', comp:91, compColor:'var(--accent)', risk:'Low', riskColor:'var(--accent)', status:'ready', statusLabel:'Ready', action:'Review', actionScreen:'validation' },
  { no:'INV-2024-1177', supplier:'Deccan Petroleum', date:'29 Jun', amount:'₹22.1 L', gst:'✔ Valid', comp:67, compColor:'var(--warn)', risk:'Medium', riskColor:'var(--warn)', status:'pending', statusLabel:'Pending', action:'Review', actionScreen:'validation' },
];

const FILTERS = ['All (47)', 'Ready (31)', 'Pending (8)', 'In review (4)', 'High risk (4)'];
const FILTER_STATUSES = [null, 'ready', 'pending', 'review', 'risk'];

export default function Invoices({ navigate }) {
  const [activeFilter, setActiveFilter] = useState(0);
  const filtered = activeFilter === 0 ? ALL_INVOICES : ALL_INVOICES.filter(i => i.status === FILTER_STATUSES[activeFilter]);

  return (
    <div>
      <FilterPills items={FILTERS} active={activeFilter} onSelect={setActiveFilter} />
      <Card>
        <div className={s.tableWrap}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>Invoice no.</th><th>Supplier</th><th>Date</th><th>Amount</th>
                <th>GST</th><th>Compliance</th><th>Risk</th><th>Status</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(inv => (
                <tr key={inv.no}>
                  <td style={{color:'var(--info)'}}>{inv.no}</td>
                  <td>{inv.supplier}</td>
                  <td style={{color:'var(--muted)'}}>{inv.date}</td>
                  <td style={{fontWeight:500}}>{inv.amount}</td>
                  <td style={{fontSize:11,color:inv.gst.startsWith('✔')?'var(--accent)':'var(--warn)'}}>{inv.gst}</td>
                  <td><span style={{color:inv.compColor,fontWeight:600}}>{inv.comp}/100</span></td>
                  <td><span style={{color:inv.riskColor,fontSize:11,fontWeight:500}}>{inv.risk}</span></td>
                  <td><Pill type={inv.status}>{inv.statusLabel}</Pill></td>
                  <td>
                    <button className={s.actionBtn} onClick={() => navigate(inv.actionScreen)}>
                      {inv.action}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
